var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[(_vm.loading)?_c('div',[_c('loading')],1):_vm._e(),_c('grid-solicitudes-cambio',{key:_vm.gridDocumento,attrs:{"rowsTable":_vm.rowsTable,"contratoId":_vm.idContrato}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }